    import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { ICourse } from '../../store/interface'
import SearchBox from './searchBox';
import SearchResult from './searchResult';
import { IUser } from '../../store/interface'
import { fetchRequest as getCourseAction} from '../../store/course/actions'
import { getCourse, getCourseByCategory } from '../../store/course/selectors';
import {
    Container, Col, Row, Card, CardImg, CardTitle, CardText, CardGroup,
    CardSubtitle, CardBody, Spinner
} from 'reactstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import queryString from 'query-string'

interface PropsFromState {
    route: any
    data: any
    loading: boolean
    totalDoc: number
    user: IUser
}

interface IState {
    firstLoad : boolean
    term : string
    profession : string
    country : string
    sorting : string
    offset: number
    limit: number
}

interface PropsFromDispatch {
    fetchRequest : typeof getCourseAction
}

type AllProps = PropsFromState & PropsFromDispatch

class CoursePage extends React.Component<AllProps, IState> {

    constructor(props: AllProps) {
        super(props);
        this.state = {
            firstLoad : true,
            term : '',
            profession : '',
            country:'',
            sorting: '',
            offset : 0,
            limit: 10
        };
    }

    public componentDidMount() {
        const { fetchRequest: fr, data } = this.props

        // const values = queryString.parse(this.props.route.location.search);
        // console.log(values.filter) // "top"
        // console.log(values.origin) // "im"

        //console.log("params:"+ JSON.stringify(this.props.route.location.search));
        const parsed = queryString.parse(this.props.route.location.search);
        //console.log(parsed);
        //this.setState({term:this.props.route.params.term});

        var searchParams:any = {};
        var sTerm = '';
        var sProfession = '';
        var sCountry = '';
        var sSorting = '';
        if (parsed.term) sTerm = parsed.term.toString();
        if (parsed.profession) sProfession = parsed.profession.toString();
        if (parsed.country) sCountry = parsed.country.toString();
        if (parsed.sorting) sSorting = parsed?.sorting.toString()??"Title";
        
        //Incluce All Country (AX) if search for specific Country
        let countryList = sCountry;
        if (countryList != '' && countryList != "All Country") { 
            countryList = "AX," + countryList;
        }

        searchParams["searchTerm"] = sTerm;
        searchParams["searchProfession"] = sProfession;
        searchParams["searchCountry"] = countryList;
        searchParams["sorting"] = sSorting;
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        //if (data.length === 0)
        if (this.state.firstLoad){
            this.setState({firstLoad : false, 
                term : sTerm, 
                profession : sProfession, 
                country : sCountry,
                sorting: sSorting
            }, () => {
                fr(searchParams);
            });
        }
    }

    private Search(d:any) { 
        //console.log('The link was clicked.');
        //this.setState({ playing:true});
        // console.log("Trigger Search!")
        // //this.setState({term: d});
        // console.log("Return :" + d.searchTerm);
        this.setState({offset : 0, 
            term : d.searchTerm.toLowerCase(), 
            profession : d.searchProfession, 
            country : d.searchCountry}, () => {

            this.props.route.history.push('?term=' + d.searchTerm + '&profession=' + encodeURIComponent(d.searchProfession) + '&country=' + d.searchCountry + '&sorting=' + this.state.sorting );

            //Incluce All Country (AX) if search for specific Country
            let countryList = this.state.country;
            if (countryList != "All Country") { 
                //countryList = "AX," + this.props.user.country;
                countryList = "AX," + countryList;
            }
            
            var searchParams:any = {};
            searchParams["searchTerm"] = this.state.term;
            searchParams["searchProfession"] = this.state.profession;
            searchParams["searchCountry"] = countryList; 
            searchParams["sorting"] = this.state.sorting;
            searchParams["offset"] = this.state.offset;
            searchParams["limit"] = this.state.limit;
            //console.log("searchParams:"+ JSON.stringify(searchParams));
            this.props.fetchRequest(searchParams);
        });
    }
    private LoadMore(d:any) { 
        this.setState({offset : this.state.offset +  this.state.limit}, () => {
            let countryList = this.state.country;
            if (countryList != "All Country") { 
                countryList = "AX," + countryList;
            }

            var searchParams:any = {};
            searchParams["searchTerm"] = this.state.term;
            searchParams["searchProfession"] = this.state.profession;
            searchParams["searchCountry"] = countryList;
            searchParams["sorting"] = this.state.sorting;
            searchParams["offset"] = this.state.offset;
            searchParams["limit"] = this.state.limit;
            this.props.fetchRequest(searchParams);
        }); 
    }

    private Sorting(d:any) { 
        //console.log("searchSorting:" + d.searchSorting);
        let countryList = this.state.country;
        if (countryList != "All Country") { 
            countryList = "AX," + countryList;
        }
        
        this.setState({offset : 0, sorting : d.searchSorting}, () => {
            
            this.props.route.history.push('?term=' + this.state.term + '&profession=' + this.state.profession + '&country=' + this.state.country + '&sorting=' + this.state.sorting );

            var searchParams:any = {};
            searchParams["searchTerm"] = this.state.term;
            searchParams["searchProfession"] = this.state.profession;
            searchParams["searchCountry"] = countryList;
            searchParams["sorting"] = this.state.sorting;
            searchParams["offset"] = this.state.offset;
            searchParams["limit"] = this.state.limit;
            this.props.fetchRequest(searchParams);
        }); 
    }

    public render() {

        return (
            // <Container>
            //     {/* <SearchBox keyword={this.props.Search.bind(this)} /> */}
            // </Container>
            <Container>
                <br />
                <Col lg="12"><h3>Learning Shelf</h3></Col>
                {/* <Col lg="12">
                    <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ips
                    </p>
                </Col> */}
                {/* {
                    JSON.stringify(this.props.user)
                }  */}
                <br />
                <SearchBox onSearch={this.Search.bind(this)} 
                    term={this.state.term} 
                    profession={this.state.profession} 
                    country={this.state.country} 
                    loading={this.props.loading} />
                <br />
                <SearchResult 
                    onLoadMore={this.LoadMore.bind(this)} 
                    onSorting={this.Sorting.bind(this)} 
                    term={this.state.term} 
                    sorting={this.state.sorting}
                    profession={this.state.profession} 
                    data={this.props.data} 
                    loading={this.props.loading} 
                    firstLoad = {this.state.firstLoad}
                    totalDocument={this.props.totalDoc} 
                    offset={this.state.offset} limit={this.state.limit}  />
                {<div>   
                    {/* {JSON.stringify(this.props.data)} */}
                    {/* {this.props.loading} */}
                </div>}

                
                <br/><br/><br/><br/><br/><br/>
                <div className="container">
                            <Col>
                                <div style={{textAlign:"center"}}>
                                    <h4>Payment Method</h4> 
                                </div>
                            </Col>
                        </div>
                        <div className="clearfix">
                            <Col lg="12" style={{textAlign:"center"}}>
                                    <span className="paymentmethod alliance"></span>
                                    <span className="paymentmethod affin"></span>
                                    <span className="paymentmethod ambank"></span>
                                    <span className="paymentmethod bsn"></span>
                                    <span className="paymentmethod hsbc"></span>
                                    <span className="paymentmethod kuwait"></span>
                                    <span className="paymentmethod ocbc"></span>
                                    <span className="paymentmethod rhb"></span>
                                    <span className="paymentmethod uob"></span>
                            </Col>
                        </div>
                        <div className="clearfix">
                            <Col lg="12" style={{textAlign:"center"}}>
                                <span className="paymentmethod islam"></span>
                                <span className="paymentmethod muamalat"></span>
                                <span className="paymentmethod cimb"></span>
                                <span className="paymentmethod hongleong"></span>
                                <span className="paymentmethod rakyat"></span>
                                <span className="paymentmethod maybank"></span>
                                <span className="paymentmethod pbebank"></span>
                                <span className="paymentmethod standardcharted"></span>
                            </Col>
                        </div>
                        <div className="clearfix">
                            <Col lg="12" style={{textAlign:"center"}}>
                                <span className="paymentmethod visa"></span>
                                <span className="paymentmethod master"></span>
                                <span className="paymentmethod boost"></span>
                                <span className="paymentmethod tng"></span>
                                <span className="paymentmethod grab"></span>
                                <span className="paymentmethod maybankqr"></span>
                            </Col>
                        </div>
            </Container>
        )
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    loading: state.course.ui.loading,
    totalDoc: state.course.ui.totDoc,
    errors: state.course.ui.errors,
    data: getCourse(state),
    coursesByCategory: getCourseByCategory(state),
    //user: state.userReducer
    user: state.userInfo.byId[0]
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getCourseAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CoursePage)
